export default __webpack_public_path__ + "static/media/icon-row-new-release.ab7c0c69.svg";